import React from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
function addressmap() {
  return (
    <div>
    <div className="flex h-screen items-center mt-40 md:mt-10 justify-center p-5">
  <div className="flex w-full flex-col md:flex-row gap-10 md:gap-12">

    {/* Address Box 1 */}
    <div className="flex flex-1 flex-col items-start rounded border p-8 shadow-lg">
      {/* Phone Number Section */}
      <div className="mb-4 flex items-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full border bg-[#2575fc] text-white hover:border-[#2575fc] hover:bg-white hover:text-[#2575fc]">
          <FaPhoneAlt className="text-2xl" />
        </div>
        <div className="ml-4">
          <p className="text-lg font-medium text-black">Phone Number</p>
          <p className="text-[16px] font-bold text-black">
            <a href="tel:+971 50 287 0799" className="hover:underline">
              +971 50 287 0799
            </a>
          </p>
        </div>
      </div>

      {/* Email Section */}
      <div className="mb-4 mt-5 flex items-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full border bg-[#2575fc] text-white hover:border-[#2575fc] hover:bg-white hover:text-[#2575fc]">
          <FaEnvelope className="text-2xl" />
        </div>
        <div className="ml-4">
          <p className="text-lg font-medium text-black">Email</p>
          <p className="text-[20px] font-bold text-black">
            <a href="mailto:info@visaworlds.net" className="hover:underline">
              info@visaworlds.net
            </a>
          </p>
        </div>
      </div>

      {/* Location Section */}
      <div className="mt-5 flex items-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full border bg-[#2575fc] text-white hover:border-[#2575fc] hover:bg-white hover:text-[#2575fc]">
          <FaMapMarkerAlt className="text-2xl" />
        </div>
        <div className="ml-4 w-full">
          <p className="text-lg font-medium text-black">Location</p>
          <p className="text-base text-black">
            <a
              href="https://www.google.com/maps?q=Level+7-1+Menara+Rajawali,+Jl.+DR+Anak+Agung+Gde+Agung,+Lot+5.1,+Mega+Kuningan,+Jakarta+Selatan,+Indonesia,+12950"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
               Tamani Arts Office, Business Bay, Dubai,
              United Arab Emirates.
            </a>
            <br />
            
          </p>
        </div>
      </div>
    </div>

    {/* Address Box 2 */}
    <div className="flex flex-1 flex-col items-start rounded border p-8 shadow-lg">
      {/* Phone Number Section */}
      <div className="mb-4 flex items-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full border bg-[#2575fc] text-white hover:border-[#2575fc] hover:bg-white hover:text-[#2575fc]">
          <FaPhoneAlt className="text-2xl" />
        </div>
        <div className="ml-4">
          <p className="text-lg font-medium text-black">Phone Number</p>
          <p className="text-[16px] font-bold text-black">
            <a href="tel:+971502870800" className="hover:underline">
              +1(929) 309 1457
            </a>
          </p>
        </div>
      </div>

      {/* Email Section */}
      <div className="mb-4 mt-5 flex items-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full border bg-[#2575fc] text-white hover:border-[#2575fc] hover:bg-white hover:text-[#2575fc]">
          <FaEnvelope className="text-2xl" />
        </div>
        <div className="ml-4">
          <p className="text-lg font-medium text-black">Email</p>
          <p className="text-[20px] font-bold text-black">
            <a href="mailto:contact@visaworlds.net" className="hover:underline">
              info@visaworlds.net
            </a>
          </p>
        </div>
      </div>

      {/* Location Section */}
      <div className="mt-5 flex items-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full border bg-[#2575fc] text-white hover:border-[#2575fc] hover:bg-white hover:text-[#2575fc]">
          <FaMapMarkerAlt className="text-2xl" />
        </div>
        <div className="ml-4 w-full">
          <p className="text-lg font-medium text-black">Location</p>
          <p className="text-base text-black">
            <a
              href="https://www.google.com/maps?q=RBK+Consultancy+Services+LLC+244+5th+Ave,+Suite+%23+R235,+New+York,+NY+10001,+United+States"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              
              <a />
              244 5th Ave, Suite # R235
              <a />
              New York, NY 10001, United States
            </a>
            <br />
           
            
          </p>
        </div>
      </div>
    </div>

  </div>
</div>

    </div>
  );
}

export default addressmap;
